import React from "react";
import { PrimaryButton } from "@fluentui/react";

import UserButton from "../../baseComponents/UserButton";

function splitNameAndReturnTwoInitials(name: string) {
  const words = name.split(" ");
  return `${words[0] && words[0][0]}${words[1] && words[1][0]}`;
}

export class LogInButton extends React.Component<any> {
  private loginFn = async (ev: any) => {
    ev.preventDefault();
    this.props.login();
  };
  private logoutFn = (ev: any) => {
    ev.preventDefault();
    this.props.logout();
  };

  public render(): JSX.Element {
    if (this.props.user.name !== "") {
      return (
        <UserButton
          initials={splitNameAndReturnTwoInitials(this.props.user.name)}
          name={this.props.user.name}
          onSignOut={this.logoutFn}
        />
      );
    }
    return (
      <PrimaryButton ariaDescription="Login Button" onClick={this.loginFn}>
        Login
      </PrimaryButton>
    );
  }
}

export default LogInButton;
